import classnames from 'classnames';
import { Button } from '@scramble/ui';
import IconSuccess from '@scramble/design-system/icons/check-circle.svg?react';
import IconWarning from '@scramble/design-system/icons/check-verified-02.svg?react';
import IconError from '@scramble/design-system/icons/alert-circle.svg?react';
import IconClose from '@scramble/design-system/icons/x-close.svg';
import s from './index.module.scss';

const ICONS = {
  success: IconSuccess,
  warning: IconWarning,
  error: IconError,
};

export const Card = ({
  type,
  title,
  desc,
  onClose,
  className,
  mainLabel,
  mainAction,
  secondaryLabel,
  secondaryAction,
}) => {
  const Icon = ICONS[type]
  return (
    <div className={classnames(s.wrapper, className, type)}>
      <div className={s.left}>
        <div className={classnames(s.icon, type)}>
          <Icon />
        </div>
        <div className={s.content}>
          <div className={s.title}>{title}</div>
          <div className={s.desc}>{desc}</div>
        </div>
      </div>
      <div className={s.right}>
        {mainAction && (
          <Button
            theme="neutral"
            appearance="filled"
            size="md"
            className={s.button}
            onClick={mainAction}
          >
            {mainLabel}
          </Button>
        )}

        {secondaryAction && (
          <Button
            theme="neutral"
            appearance="tonal"
            size="md"
            className={s.button}
            onClick={secondaryAction}
          >
            {secondaryLabel}
          </Button>
        )}

        {onClose && (
          <button className={s.btn_close} type="button" onClick={onClose}>
            <img src={IconClose} alt="close" width={20} height={20} />
          </button>
        )}
      </div>
    </div>
  );
};
